module.exports = __webpack_public_path__ + "img/bus_circle_blue.0404dd85.svg";